export const getLocal = (key, parse = false) => {
  if (typeof localStorage === undefined || !key) return '';
  if (parse) {
    const value = localStorage.getItem(key);
    if (value) {
      return JSON.parse(value);
    }
  }
  return localStorage.getItem(key);
};

export const setLocal = (key, value) => {
  if (typeof localStorage === undefined || !key) return;

  if (typeof value === 'object') {
    localStorage.setItem(key, JSON.stringify(value));
  } else {
    localStorage.setItem(key, value.toString());
  }
};

export const removeLocal = (key) => {
  localStorage.removeItem(key);
};

export const clearLocal = () => {
  localStorage.clear();
};

export const getSession = (key) => {
  if (typeof sessionStorage === undefined || !key) return '';
  return sessionStorage.getItem(key);
};

export const setSession = (key, value) => {
  if (typeof sessionStorage === undefined || !key) return;
  sessionStorage.setItem(key, JSON.stringify(value));
};

export const removeSession = (key) => {
  sessionStorage.removeItem(key);
};

export const clearSession = () => {
  sessionStorage.clear();
};
